import {
  TitleModule,
  SpacingModule,
  ButtonModule,
  StaggeredContentModule,
  StaggeredVisualModule,
  StaggeredCardsModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { StaggeredVisualSectionComponent } from './staggered-visual-section.component';
import { PipesModule } from '@shared/pipes/pipes.module';
import { TranslateModule } from '@shared/translate/translate.module';

@NgModule({
  declarations: [StaggeredVisualSectionComponent],
  imports: [
    BrSdkModule,
    CommonModule,
    StaggeredContentModule,
    ButtonModule,
    StaggeredVisualModule,
    StaggeredCardsModule,
    TitleModule,
    SpacingModule,
    PipesModule,
    TranslateModule,
  ],
  exports: [StaggeredVisualSectionComponent],
  entryComponents: [StaggeredVisualSectionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

/**
 * Staggered Section Module
 */
export class StaggeredVisualSectionModule {}
